const TELEMETRY_KEY_PREFIX = 'ccg_ui';
export const telemetryKeyPrefix = (key: string) => {
  return `${TELEMETRY_KEY_PREFIX}_${key}`;
};
